module.exports = __webpack_public_path__ + "src/assets/img/slider_img2.698e1181.jpg";